import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import { graphql, useStaticQuery } from "gatsby"
import discord from "../assets/images/discord.png"
import telegram from "../assets/images/telegram.png"
import twitter from "../assets/images/twitter.png"

const Social = () => {
  const data = useStaticQuery(graphql`
    {
      strapiHomePage {
        social_heading
        social_tagline
      }
    }
  `)

  const {
    strapiHomePage: { social_heading, social_tagline },
  } = data

  return (
    <Container className="social">
      <p className="text-center">{social_heading}</p>
      <Row className="justify-content-center align-items-center social-box">
        <Col lg={4} className="text-center my-3 my-lg-0">
          <a href="https://twitter.com/rjntoken">
            <img src={twitter} alt="twitter" className="my-5 my-lg-0" />
          </a>
        </Col>
        <Col lg={4} className="text-center my-3 my-lg-0">
          <a href="https://discord.gg/tf5gFHY2">
            <img src={discord} alt="discord" className="my-5 my-lg-0" />
          </a>
        </Col>
        <Col lg={4} className="text-center my-3 my-lg-0">
          <a href="https://t.me/rajininetwork">
            <img src={telegram} alt="telegram" className="my-5 my-lg-0" />
          </a>
        </Col>
      </Row>
      <h1 className="text-center my-4">{social_tagline}</h1>{" "}
    </Container>
  )
}

export default Social
